/**
 * PortfolioReviewScreen.jsx - Locked Portfolio Summary
 * Phase 3B Round 3 - Named export only
 * 
 * Extracted from gm-strategy-hub-v22.jsx lines 1156-1204
 */

import React from 'react';
import { ChevronLeft } from 'lucide-react';

// Viz components - 2 levels up from features/strategy/
import { UnitWheel, TeamStrip } from '../../components/viz';

// Builder components - 2 levels up
import PositionStrip from '../../components/builder/PositionStrip';
import OverUnderStrip from '../../components/builder/OverUnderStrip';

// Constants - 2 levels up
import { TEAM_COLORS } from '../../constants';

export const PortfolioReviewScreen = ({ pool, entry, onBack }) => {
  const roster = entry?.roster || [];
  
  return (
    <div className="min-h-screen bg-slate-100 pb-20">
      <header className="bg-white shadow-sm px-4 py-3 flex items-center">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-600 min-w-[44px] min-h-[44px] flex items-center justify-center">
          <ChevronLeft size={22} />
        </button>
        <h1 className="text-base font-bold text-slate-900 ml-2">Roster Review</h1>
      </header>
      
      <main className="p-3 space-y-3">
        <div className="bg-white rounded-xl shadow-sm p-3">
          <UnitWheel roster={roster} totalCapacity={pool?.units || 100} compact />
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-3 space-y-2">
          <div>
            <span className="text-[10px] font-semibold text-slate-400 uppercase">Position</span>
            <PositionStrip roster={roster} />
          </div>
          <div>
            <span className="text-[10px] font-semibold text-slate-400 uppercase">Above / Below</span>
            <OverUnderStrip roster={roster} />
          </div>
          <div>
            <span className="text-[10px] font-semibold text-slate-400 uppercase">Team</span>
            <TeamStrip roster={roster} />
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-3 py-2 bg-slate-50 border-b">
            <h3 className="text-[11px] font-semibold text-slate-400 uppercase">Locked Roster</h3>
          </div>
          <div className="divide-y divide-slate-100">
            {roster.filter(s => s.player).map(s => (
              <div key={s.slot} className="p-3 flex items-center gap-3">
                <div 
                  className="w-1 h-8 rounded-full" 
                  style={{ backgroundColor: TEAM_COLORS[s.player?.team] || '#64748B' }} 
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-slate-800 truncate">{s.player?.name}</p>
                  <p className="text-[10px] text-slate-500">{s.prop?.stat} {s.prop?.line}</p>
                </div>
                <div className="text-right">
                  <span className={`text-xs font-bold px-2 py-1 rounded ${s.side === 'OVER' ? 'bg-indigo-100 text-indigo-600' : 'bg-slate-200 text-slate-600'}`}>
                    {s.side === 'OVER' ? 'Above' : 'Below'}
                  </span>
                  <p className="text-[11px] font-bold text-slate-600 mt-1">{`$${s.units}`}</p>
                </div>
              </div>
            ))}
            {roster.filter(s => s.player).length === 0 && (
              <div className="p-6 text-center">
                <p className="text-sm text-slate-400">No roster data available</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};
